<template lang="html">
    <input type="text" v-on:keyup="updateValue">
</template>

<script>
	import Cleave from "cleave.js"
	import "cleave.js/dist/addons/cleave-phone.mx"

	export default {
		props: ["value", "options"],
		mounted() {
			this.cleave = new Cleave(this.$el, this.options)
			this.cleave.setRawValue(this.value)
		},
		destroyed() {
			this.cleave.destroy()
		},
		watch: {
			value: "updateInput"
		},
		methods: {
			updateValue() {
				var val = this.cleave.getRawValue()
				if (val !== this.value) {
					this.$emit("input", val)
				}
			},
			updateInput() {
				this.cleave.setRawValue(this.value)
			}
		}
	}
</script>